import { useLocation, useNavigate } from "react-router";

/** This hook preserves the query params when navigating */
export const useNavigateWithSearch = (): ((to: string, opts?: { replace: boolean }) => void) => {
  const navigate = useNavigate();
  const location = useLocation();

  return (to, opts) => {void navigate(to + location.search, opts)};
};
